import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

export default store => ({
  path: "campaigns",
  component: withAsyncRouteLoading(() =>
    import(
      /* webpackChunkName: "admissions-marketing-engagement" */ "Admissions/features/MarketingEngagement/components/Campaigns"
    ).then(m => m.default)
  ),
});
